module.exports = __webpack_public_path__ + "static/GrapeSeedFlour-07fa74d9c9402dec83437c3c7543cf04.webp";